import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x31800000 {
  settings: string;
}

export function Command0x31800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    settings: "",
  };

  const [fields, setFields] = React.useState<Form0x31800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x31800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const strIds = event.target.value.replace(/,{1,}/g, ",");
      const ids = strIds.split(",");

      handleChange(
        JSON.stringify({
          settings: ids,
        })
      );
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.settings) {
      params.settings = [];
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          id="settings"
          label="Номер настройки через запятую"
          margin="dense"
          fullWidth
          value={fields.settings}
          onChange={handleChangeField("settings")}
        />
      </FormControl>
    </>
  );
}
